import styled from '@emotion/styled';

const Table = styled.table({
  borderCollapse: 'collapse',
  width: '100%',
  textAlign: 'center'
})

export default Table;

